import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";

export type LineGridComponentProps = {
  cameraScale: number;
};

export class LineGridComponent extends Webgl2Component<LineGridComponentProps> {
  private _canRenderCameraScale = 8;

  public getRenderData(props: LineGridComponentProps) {
    if (props.cameraScale < this._canRenderCameraScale) return;

    const material = Webgl2.materials.lineGrid;
    material.setUniforms({
      u_size: this.transform.size.getAbs().getArray(),
    });
    return { material };
  }
}

export default LineGridComponent;
